import { render, staticRenderFns } from "./TicketsJiraView.vue?vue&type=template&id=e66b1674&scoped=true&"
import script from "./TicketsJiraView.vue?vue&type=script&lang=js&"
export * from "./TicketsJiraView.vue?vue&type=script&lang=js&"
import style0 from "./TicketsJiraView.vue?vue&type=style&index=0&id=e66b1674&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66b1674",
  null
  
)

export default component.exports